import { getAuditedBaseRawAttributes } from "./helper.js";
import pluralize from "pluralize";

export const defineAuditedModel =
  (sequelize, Sequelize, Version) => (modelName, modelAttributes, options) => {
    const Model = sequelize.define(
      pluralize(modelName),
      {
        ...getAuditedBaseRawAttributes(Sequelize),
        ...modelAttributes,
      },
      options
    );

    Model.Version = Version(Model);

    return Model;
  };
